import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'regularCase'})
export class RegularCasePipe implements PipeTransform {
  public transform(value:string): string{
    if (!value) {
      return '';
    } else {
      return value.replace(/([A-Z])/g, ' $1').replace(/^./, (str)=>str.toUpperCase() );
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/pipes/regularText.pipe.ts